import React from 'react';
import PropTypes from 'prop-types';
import validate from 'stripe-card-validator';
import MaskedInput from 'react-text-mask';

const cardIcons = {
  mastercard: '/assets/images/creditcard/mastercard.png',
  visa: '/assets/images/creditcard/visa.png',
  'american express': '/assets/images/creditcard/amex.png',
};

export default function CreditCardInput({ value, className, onChange, onFocus, onBlur }) {
  let cardType;

  try {
    cardType = validate(value || '');
  } catch (e) {
    cardType = null;
  }

  const mask = cardType === 'american express' ?
    '____ ______ _____' :
    '____ ____ ____ ____';

  const realMask = [];
  for (let i = 0; i < mask.length; i += 1) {
    realMask.push(mask[i] === '_' ? /\d/ : ' ');
  }

  const style = {
    backgroundImage: cardType ? `url(${cardIcons[cardType]})` : null,
  };

  return (
    <div className="CCNumberInput">
      <MaskedInput
        type="text"
        placeholder="Card Number"
        mask={realMask}
        className={className}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        value={value}
      />
      <div className="CCNumberInput__Card" style={style} />
    </div>
  );
}

CreditCardInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
};




// WEBPACK FOOTER //
// ./app/form/CreditCardInput.jsx